
import React, { Component } from 'react'
import moment from "moment"

export default class ProfileExpiredAuction extends Component {
  render() {
    const { data, back } = this.props
    return (
        <div className='ProfileContainer'>
            <div className='ProfileContainer__wrapper'>
                <div className='ProfileContainer__header'>
                    {/* <div className='ProfileContainer__header-arrow'></div> */}
                    <img className='ProfileContainer__header-arrow' src="/assets/img/arrow.png" onClick={back} alt="" />
                    <p className='ProfileContainer__header-left'>{moment(data.startDate).add(3, 'hours').utc().format('Аукцион от DD/MM/YYYY')}</p>
                    <p className='ProfileContainer__header-right'>aукцион завершился {moment(data.closeDate).fromNow()}</p>
                </div>
                <div className='ProfileContainer__main ProfileContainer__main_grid'>
                    <div className='ProfileContainer__output'>
                        <p className='ProfileContainer__output-top'>Статус</p>
                        <div  className='ProfileContainer__output-main'>
                         {data.status === "complete"? "Завершённый" : "Отменённый"}
                        </div>
                    </div>
                    <div className='ProfileContainer__output'>
                        <p className='ProfileContainer__output-top'>Дата завершения</p>
                        <div  className='ProfileContainer__output-main'>
                        {moment(data.closeDate).format("DD/MM/YYYY")}
                        </div>
                    </div>
                    <div className='ProfileContainer__output'>
                        <p className='ProfileContainer__output-top'>Победная ставка</p>
                        <div  className='ProfileContainer__output-main'>
                        {data.sum}
                        </div>
                    </div>
                    <div className='ProfileContainer__output'>
                        <p className='ProfileContainer__output-top'>Победитель</p>
                        <div  className='ProfileContainer__output-main'>
                        {data.winner}
                        </div>
                    </div>
                    <div className='ProfileContainer__output'>
                        <p className='ProfileContainer__output-top'>Статус оплаты</p>
                        <div  className='ProfileContainer__output-main'>
                        {data.paidStatus === "Paid" ? "Оплачено" : "Не оплачено"}
                        </div>
                    </div>
                    <div className='ProfileContainer__output'>
                        <p className='ProfileContainer__output-top'>Фонд</p>
                        <div  className='ProfileContainer__output-main'>
                        {data.fund}
                        </div>
                    </div>
                    <div className='ProfileContainer__output'>
                        <p className='ProfileContainer__output-top'>Дата перевода пожертвования в фонд</p>
                        <div  className='ProfileContainer__output-main'>
                        {moment(data.closeDate).format("DD/MM/YYYY")}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/PersonProfile/ProfileContainers/ProfileExpiredAuctionCard.jsx